export enum DiscoverSubmissionTypes {
  academic = 'academic',
  biotechAsset = 'biotechAsset',
  centreOfExcellence = 'centreOfExcellence',
  researchProject = 'researchProject',
  spinout = 'spinout',
  technology = 'platformTechnology',
  externalTechnology = 'technology',
  rfpApplication = 'rfpApplication',
}
